"use strict"; // https://html.spec.whatwg.org/multipage/obsolete.html#dom-external

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

exports.implementation = /*#__PURE__*/function () {
  function ExternalImpl() {
    _classCallCheck(this, ExternalImpl);
  }

  _createClass(ExternalImpl, [{
    key: "AddSearchProvider",
    value: // The AddSearchProvider() and IsSearchProviderInstalled() methods must do nothing
    function AddSearchProvider() {}
  }, {
    key: "IsSearchProviderInstalled",
    value: function IsSearchProviderInstalled() {}
  }]);

  return ExternalImpl;
}();